import { useEffect, useMemo, useState } from 'react';
import { Menu } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useNavigateApi from '../../appRoute/useNavigateApi';
import './SettingsLayout.scss';

const SettingsMenu = ({ onSelect }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigateApi = useNavigateApi();

  const [selectedMenuKey, setSelectedMenuKey] = useState(location.pathname);

  const lang = useSelector((state) => {
    return state.lang;
  });

  const isUser1C = useSelector((state) => {
    return state.currentUser?.is1c;
  });

  const items = useMemo(() => {
    return [
      {
        key: `/${lang}/settings/company`,
        label: t('WORD_COMPANY_SETTINGS'),
        onClick: () => {
          navigateApi(`/settings/company`);
        },
      },
      {
        key: `/${lang}/settings/account`,
        label: t('WORD_ACCOUNT_SETTINGS'),
        onClick: () => {
          navigateApi(`/settings/account`);
        },
      },
      // {
      //   key: `/${lang}/settings/password`,
      //   label: t('WORD_PASSSWORD_CHANGE'),
      //   onClick: () => {
      //     navigateApi(`/settings/password`);
      //   },
      // },
      {
        key: `/${lang}/settings/general`,
        label: t('WORD_GENERAL_SETTINGS'),
        onClick: () => {
          navigateApi(`/settings/general`);
        },
      },
      {
        key: `/${lang}/settings/policy`,
        label: t('WORD_POLICIES'),
        onClick: () => {
          navigateApi(`/settings/policy/list`);
        },
      },
      {
        key: `/${lang}/settings/payment`,
        label: t('WORD_PAYMENT_TYPES'),
        onClick: () => {
          navigateApi(`/settings/payment`);
        },
      },
      {
        key: `/${lang}/settings/package`,
        label: t('WORD_PACKAGE_DETAILS'),
        onClick: () => {
          navigateApi(`/settings/package`);
        },
      },
      // {
      //   label: t("WORD_PRODUCT_UNITS"),
      //   key: `/${lang}/settings/product`,
      //   onClick: () => {
      //     navigateApi(`/settings/product`);
      //   },
      // },
      {
        key: `/${lang}/settings/importxml`,
        label: t('WORD_IMPORT_XML'),
        onClick: () => {
          navigateApi(`/settings/importxml`);
        },
      },
      {
        key: `/${lang}/settings/exportTemplates`,
        label: t('WORD_EXPORT_TEMPLATES'),
        onClick: () => {
          navigateApi(`/settings/exportTemplates/list`);
        },
      },
      {
        key: `/${lang}/settings/apikey`,
        label: t('WORD_API_ACCESS_TOKEN'),
        onClick: () => {
          navigateApi(`/settings/apikey/list`);
        },
      },
      {
        key: `/${lang}/settings/inventory`,
        label: t('WORD_INVENTORY'),
        onClick: () => {
          navigateApi(`/settings/inventory`);
        },
      },
      {
        key: `/${lang}/settings/devices`,
        label: t('WORD_DEVICES'),
        onClick: () => {
          navigateApi(`/settings/devices/list`);
        },
      },
      {
        key: `/${lang}/settings/branch`,
        label: t('WORD_BRANCHES'),
        onClick: () => {
          navigateApi(`/settings/branch/list`);
        },
      },
      {
        key: `/${lang}/settings/clearArchive`,
        label: t('WORD_CLEAR_ARCHIVE'),
        onClick: () => {
          navigateApi(`/settings/clearArchive`);
        },
      },
      {
        key: `/${lang}/settings/storage`,
        label: t('WORD_STORAGE'),
        onClick: () => {
          navigateApi(`/settings/storage`);
        },
      },
      ...(process.env.NODE_ENV === 'development' && !isUser1C
        ? [
            {
              key: `/${lang}/settings/filemanager`,
              label: t('WORD_FILE_MANAGER'),
              onClick: () => {
                navigateApi(`/settings/filemanager`);
              },
            },
          ]
        : []),
    ];
  }, [isUser1C, lang, navigateApi, t]);

  useEffect(() => {
    const getPathForSelection = (pathname) => {
      if (pathname === `/${lang}/settings/password`) {
        return `/${lang}/settings/account`;
      }
      return pathname;
    };

    const pathnameForSelection = getPathForSelection(location.pathname);
    const matchedItem = items.find((item) =>
      pathnameForSelection.startsWith(item.key)
    );
    setSelectedMenuKey(matchedItem ? matchedItem.key : pathnameForSelection);
  }, [lang, location.pathname, items]);

  return (
    <Menu
      items={items}
      mode="vertical"
      defaultSelectedKeys={['1']}
      className="second_side_menu"
      selectedKeys={[selectedMenuKey]}
      onSelect={(menu) => {
        onSelect && onSelect(menu);
      }}
      style={{
        borderInlineEnd: 'none',
      }}
    />
  );
};

export default SettingsMenu;
